import { MyOskSubscriptionsService } from '../../../../api/api-services/my-osk-subscriptions.service';
import { IMyOskSubscriptonsVm } from '../../../../api/my-osk-subscriptons-vm.model';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FASDynamicTableColumnConfig } from 'fas-services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-osk-available-subscriptions-list',
  templateUrl: './osk-available-subscriptions-list.component.html',
  styleUrl: './osk-available-subscriptions-list.component.scss',
})
export class OskAvailableSubscriptionsListComponent {
  private _myOskSubscriptionsService = inject(MyOskSubscriptionsService);

  @Output() buyCurrentSubscriptionEvent = new EventEmitter<string>();

  public columns: FASDynamicTableColumnConfig<IMyOskSubscriptonsVm>[] = [
    {
      field: 'planName',
      columnHeader: 'Nazwa abonamentu',
      columnTemplateKey: 'planNameTemplate',
    },
    {
      field: 'availablePlans',
      columnClass: 'w-full flex align-items-center justify-content-between',
      columnHeader: 'Ilość dostępnych abonamentów',
      actions: [
        {
          label: 'Zakup ten abonament',
          buttonClass: 'white-button appear',
          icoSuffix: 'pi pi-arrow-right',
          callback: (data: IMyOskSubscriptonsVm) =>
            this.buyCurrentSubscriptionPlan(data),
        },
      ],
    },
    // TODO - temporary hidden - https://monito.atlassian.net/browse/PRAW-292
    // {
    //   columnHeader: 'Akcje',
    //   actions: [
    //     {
    //       label: 'Przydziel abonament',
    //       buttonClass: 'blue-button appear',
    //       icoPrefix: 'pi pi-user-edit',
    //       callback: (data: IMyOskSubscriptonsVm, rowIndex: number) =>
    //         this.assignSubscription(data, rowIndex),
    //     },
    //   ],
    // },
  ];

  fetchOskSubscriptionPlans = (): Observable<IMyOskSubscriptonsVm[]> => {
    return this._myOskSubscriptionsService.get();
  };


  buyCurrentSubscriptionPlan(
    data: IMyOskSubscriptonsVm,
  ): void {
    this.buyCurrentSubscriptionEvent.emit(data.planGuid);
  }

  assignSubscription(
    data: IMyOskSubscriptonsVm,
    rowIndex: number
  ): void {
    console.log('Assign subscription plan to be implemented', data);
  }
}
